<style scoped lang="stylus">
.incident-banner
  position: relative
  width: 100vw
  left: 50%
  right: 50%
  margin-left: -50vw
  margin-right: -50vw
  margin-bottom: 8px
  display: flex
  justify-content: space-between
  align-items: center
  padding: 12px 24px
  font-family: Arial, sans-serif
  font-size: 14px
  line-height: 20px
  flex-wrap: wrap

.incident-banner--orange
  background-color: #FFF4E5
  border: 1px solid #C87C00

.incident-banner--red
  background-color: #FDECEA
  border: 1px solid #C62828

.incident-banner--blue
  background-color: #E8F1FB
  border: 1px solid #1565C0

.incident-banner--yellow
  background-color: #FEF8E3
  border: 1px solid #C8A200

.incident-banner__center-wrapper
  display: flex
  justify-content: center
  flex: 1
  max-width: 900px
  margin: 0 auto
  width: 100%

.incident-banner__left
  display: flex
  align-items: center
  gap: 8px
  max-width: 100%

.incident-banner__text
  font-weight: 400
  margin: 0
  padding-left: 2px
  text-indent: -2px
  display: block
  line-height: 20px

.incident-banner--orange .incident-banner__text
  color: #663C00

.incident-banner--red .incident-banner__text
  color: #611A15

.incident-banner--blue .incident-banner__text
  color: #0D3C61

.incident-banner--yellow .incident-banner__text
  color: #5C4D00

.incident-banner__text strong
  font-weight: 700
  margin-right: 6px

@media (max-width: 768px)
  .incident-banner
    flex-wrap: wrap
    flex-direction: row
    align-items: center
    padding: 12px

  .incident-banner__center-wrapper
    flex: 1
    margin: 0
    max-width: 100%

  .incident-banner__left
    align-items: center
    gap: 8px
    text-align: left
    max-width: 100%

  .incident-banner__text
    max-width: 100%
    padding-left: 2px
    text-indent: -2px
    margin: 0
</style>

<template>
  <div class="incident-banner" :class="`incident-banner--${variant}`" v-if="show">
    <div class="incident-banner__center-wrapper">
      <div class="incident-banner__left">
        <v-icon :color="iconColor" size="24"> {{ icon }} </v-icon>
        <div class="incident-banner__text">
          <strong v-if="title">{{ title }}</strong>
          <span v-if="html" v-html="message"></span>
          <template v-else>{{ message }}</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

const VARIANT_ICON_COLORS = {
  orange: '#C87C00',
  red: '#C62828',
  blue: '#1565C0',
  yellow: '#C8A200'
};

export default defineComponent({
  name: 'NoticeBanner',

  props: {
    show: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'orange',
      validator: (value) => ['orange', 'red', 'blue', 'yellow'].includes(value)
    },
    icon: {
      type: String,
      default: 'mdi-alert-circle'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    // When true, message is rendered as HTML (rich-text announcement bodies).
    html: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    iconColor() {
      return VARIANT_ICON_COLORS[this.variant] || VARIANT_ICON_COLORS.orange;
    }
  }
});
</script>
